import { render, staticRenderFns } from "./CoozzyAngleDoubleDownIcon.vue?vue&type=template&id=18cd946a&scoped=true"
import script from "./CoozzyAngleDoubleDownIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAngleDoubleDownIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAngleDoubleDownIcon.vue?vue&type=style&index=0&id=18cd946a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd946a",
  null
  
)

export default component.exports